// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={213}
      height={50}
      viewBox="0 0 213 50"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#E2001A"
          stroke="#000"
          d="m191.188 39.38.718-.062 3.875 9.125-.875-.157z"
        />
        <path
          fill="#6F4C84"
          stroke="#000"
          d="m186.368 11.415-.153-.358 9.653-2.205.108.26z"
        />
        <path
          fill="#885FA0"
          stroke="#000"
          d="m182.218 2.399.094-.251.215-.036 3.765 9.075-.05.004-.022.036z"
        />
        <path
          fill="#885FA0"
          d="m181.242 18.262 2.11.808-6.932 18.113-2.11-.808z"
        />
        <path fill="#00A2AC" d="M173.352 35.394h18.211v5.828h-18.211z" />
        <path
          fill="#543864"
          d="m170.835 36.398 13.529-4.272 1.091 3.455-13.53 4.272z"
        />
        <path
          fill="#00A2AC"
          d="m168.916 32.704 7.06 2.645-1.122 2.996-7.06-2.645z"
        />
        <path
          fill="#00A2AC"
          d="m195.456 48.492-30.616-5.499 3.271-7.666 23.384 4.004z"
        />
        <path
          fill="#000"
          fillRule="nonzero"
          d="M127.438 10.844c-2.316 0-4.22 1.902-4.22 4.219 0 2.315 1.904 4.218 4.22 4.218 2.318 0 4.218-1.903 4.218-4.218 0-2.317-1.9-4.22-4.219-4.22ZM0 11.875V43h7.531V32.125c0-2.481.96-5.063 3.938-5.063 3.019 0 3.375 2.582 3.375 5.063V43h7.531V30c0-5.378-2.596-8.938-7.969-8.938-2.937 0-5.073 1.092-6.812 3.407H7.53V11.875H0Zm50.094 0V43h7.531V11.875h-7.531Zm60.375 3.531v6.375h-2.438v6.188h2.438V43H118V27.969h4.25V21.78H118v-6.375h-7.531ZM36.28 21.062c-6.91 0-11.75 4.27-11.75 11.344 0 7.322 5.25 11.281 12.282 11.282 4.837 0 9.58-2.278 10.78-7.282h-7.218c-.828 1.405-1.981 1.969-3.594 1.969-3.102 0-4.718-1.662-4.718-4.719h15.843v-.812c0-7.238-4.265-11.782-11.625-11.782Zm58.969 0c-6.905 0-11.719 4.27-11.719 11.344 0 7.322 5.251 11.281 12.281 11.282 4.837 0 9.584-2.278 10.782-7.282h-7.25c-.826 1.405-1.981 1.969-3.594 1.969-3.103 0-4.719-1.662-4.719-4.719h15.844v-.812c0-7.238-4.264-11.782-11.625-11.782Zm48.781 0c-6.288 0-10.625 5.23-10.625 11.313 0 6.08 4.4 11.312 10.688 11.313 2.482 0 5.081-.952 6.406-3.063h.094V43h7.531V21.781h-7.531v2.063c-1.573-1.863-4.126-2.782-6.563-2.782Zm-85.656.72L69.5 43h4.781l11.094-21.219h-8.438l-5.062 10.875-5.063-10.875h-8.437Zm65.313 0V43h7.5V21.781h-7.5Zm-87.032 4.155c2.028 0 3.877 1.35 4.25 3.375h-8.718c.457-2.19 2.277-3.375 4.468-3.375Zm58.969 0c2.026 0 3.91 1.35 4.281 3.375h-8.75c.454-2.19 2.277-3.375 4.469-3.375ZM146 27.595c3.059 0 4.844 2.207 4.844 4.812 0 2.689-1.785 4.75-4.844 4.75-3.061 0-4.844-2.061-4.844-4.75 0-2.605 1.783-4.812 4.844-4.812Z"
        />
        <path
          fill="#885FA0"
          d="m185.341 10.622 2.825 1.903-5.38 7.983-2.824-1.903z"
        />
        <path
          fill="#543864"
          d="m185.094 18.656-2.313.563-7.5 17.344 9.657-2.5L188.031 27z"
        />
        <path
          fill="#6F4C84"
          d="M182.305 2.125 192.042 0l3.916 8.984-9.705 2.233z"
        />
        <path
          fill="#885FA0"
          d="m168.111 35.327 14.194-33.201 3.949 9.091-10.97 25.339z"
        />
        <path
          fill="#006C73"
          d="m184.938 34.063-9.657 2.5 16.219 2.78 1.094-.28c-.055-.14-.807-1.855-1.75-4l-5.906-1Z"
        />
        <path
          fill="#E2001A"
          d="m182.789 19.209 3.465-7.992 16.76 38.631-7.558-1.356z"
        />
        <path
          fill="#B70618"
          d="m186.253 11.217 9.705-2.233 16.64 38.166-9.585 2.699z"
        />
      </g>
    </svg>
  );
};

const HelvetiaIcon = Icon;
export default HelvetiaIcon;
